import {
    PRODUCTION_DETAIL_GRAY_REPORT_REQUEST,
    PRODUCTION_DETAIL_GRAY_REPORT_SUCCESS,
    PRODUCTION_DETAIL_GRAY_REPORT_FAILURE,
    PRODUCTION_DETAIL_GRAY_FILTER_REPORT_REQUEST,
    PRODUCTION_DETAIL_GRAY_FILTER_REPORT_SUCCESS,
    PRODUCTION_DETAIL_GRAY_FILTER_REPORT_FAILURE
  } from "../types/production-detail-gray-report-types";
  
const initialState = {
    productionDetailGrayReport: {},
    productionDetailGrayFilterOptions: {},
    loading: false,
    error: null,
};

const productionDetailGrayReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case PRODUCTION_DETAIL_GRAY_REPORT_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null,
                productionDetailGrayReport: {}
            };
        }
        case PRODUCTION_DETAIL_GRAY_FILTER_REPORT_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            };
        }
        case PRODUCTION_DETAIL_GRAY_REPORT_SUCCESS: {
            return {
                ...state,
                productionDetailGrayReport: {...(action.payload || {})},
                loading: false,
                error: null
            };
        }
         case PRODUCTION_DETAIL_GRAY_FILTER_REPORT_SUCCESS: {
            return {
                ...state,
                productionDetailGrayFilterOptions: {...(action.payload || {})},
                loading: false,
                error: null
            };
        }
        case PRODUCTION_DETAIL_GRAY_REPORT_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.error
            };
        }
         case PRODUCTION_DETAIL_GRAY_FILTER_REPORT_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.error
            };
        }
        default:
        return state;
    }
};

export default productionDetailGrayReportReducer;